export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/schedule/resources/mounted.js